import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { OtInputText } from '@1trading/design-system';
import { ref } from 'vue';

import { capToggleStatusBar } from '@exchange/libs/utils/capacitor/src';

import useInputFocusFallback from './useInputFocusFallback';


export default /*#__PURE__*/_defineComponent({
  __name: 'XInputText',
  setup(__props) {

const inputTextRef = ref<InstanceType<typeof OtInputText> | null>();

const { onFocusCb, onBlurCb } = useInputFocusFallback();

const onFocus = () => {
  const elem = inputTextRef.value?.inputTextRef;

  if (elem) {
    onFocusCb(elem);
  }
};
const onBlur = () => {
  onBlurCb();
};
const onToggleInputState = (value: boolean) => {
  capToggleStatusBar(value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(OtInputText), _mergeProps({
    ref_key: "inputTextRef",
    ref: inputTextRef,
    class: "x-input-text"
  }, _ctx.$attrs, {
    onFocus: onFocus,
    onBlur: onBlur,
    onToggleInputState: onToggleInputState
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    })
  ]), 1040))
}
}

})